var React = require('react');

function Pt (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#6da544","d":"M0 512h167l37.9-260.3L167 0H0z","key":0}),React.createElement("path",{"fill":"#d80027","d":"M512 0H167v512h345z","key":1}),React.createElement("circle",{"cx":"167","cy":"256","r":"89","fill":"#ffda44","key":2}),React.createElement("path",{"fill":"#d80027","d":"M116.9 211.5V267a50 50 0 1 0 100.1 0v-55.6H117z","key":3}),React.createElement("path",{"fill":"#eee","d":"M167 283.8c-9.2 0-16.7-7.5-16.7-16.7V245h33.4v22c0 9.2-7.5 16.7-16.7 16.7z","key":4})])]);
}

Pt.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Pt;

Pt.default = Pt;
